"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var _react = _interopRequireDefault(require("react"));
var _carbonComponentsReact = require("carbon-components-react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ".button.bx--btn {\n  padding-right: 1rem; }\n  .button.bx--btn.bx--btn--icon-only {\n    padding-right: 0.5rem; }\n\n.button.bx--btn--primary[disabled] {\n  background: #d4d4d4;\n  border-color: #d4d4d4;\n  color: #ffffff; }\n  .button.bx--btn--primary[disabled]:hover {\n    background: #a8a8a8; }\n\n.button.bx--btn--secondary {\n  border-color: #4c4c4c;\n  color: #4c4c4c;\n  background: white; }\n  .button.bx--btn--secondary:hover {\n    background: #d4d4d4; }\n  .button.bx--btn--secondary[disabled] {\n    color: #a8a8a8;\n    border-color: #d4d4d4; }\n    .button.bx--btn--secondary[disabled]:hover {\n      color: #8d8d8d;\n      border-color: #c6c6c6; }\n";
  const fileName = "Button_Button";
  const element = document.querySelector("style[data-sass-component='Button_Button']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Button = _ref => {
  let {
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Button, _extends({
    className: 'button'
  }, props), props.children);
};
exports.Button = Button;